
import Vue from 'vue';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

const COOKIE_NAME = 'w2p_ai_preview_tooltip_shown';

export default Vue.extend({
  name: 'AiPreviewTooltip',
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    const hasSeenTooltip = this.$cookies.get(COOKIE_NAME);
    if (!hasSeenTooltip) {
      this.isVisible = true;
    }
  },
  methods: {
    handleClose() {
      this.$cookies.set(COOKIE_NAME, 'true', '365d');
      this.isVisible = false;
      this.$emit('close');
    },
    handleTryIt() {
      this.$cookies.set(COOKIE_NAME, 'true', '365d');
      this.$emit('try-it');
      this.isVisible = false;
    },
  },
});
